import { Link } from "react-router-dom";
import { ArrowUpRight, XCircle, MessageSquare } from "lucide-react";
import {
  T, FONT_DISPLAY, PageShell, TopNav, Footer,
  container, eyebrow, italicAccent, btnCoral,
} from "@/lib/hybridTheme";

export default function CheckoutCancel() {
  return (
    <PageShell testId="checkout-cancel-page">
      <TopNav />

      <section style={{ padding: "120px 0 96px" }}>
        <div style={container()}>
          <div style={{ maxWidth: 780, margin: "0 auto", textAlign: "center" }}>
            <div style={{ width: 88, height: 88, borderRadius: "50%", background: T.panel, color: T.coral, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 32px", border: `1px solid ${T.line}` }}>
              <XCircle size={44} strokeWidth={2} />
            </div>
            <div style={eyebrow()}>No charge</div>
            <h1 style={{ fontFamily: FONT_DISPLAY, fontSize: "clamp(48px, 6vw, 80px)", lineHeight: 1.02, letterSpacing: "-0.03em", fontWeight: 400, margin: "20px 0 24px", color: T.ink }}>
              Checkout <em style={italicAccent(T.coral)}>cancelled.</em>
            </h1>
            <p style={{ fontSize: 19, lineHeight: 1.55, color: T.inkMuted, maxWidth: 620, margin: "0 auto" }}>
              You weren&apos;t charged. Happens all the time — grab a demo instead and we&apos;ll walk you through it live before you spend a cent.
            </p>
            <div style={{ marginTop: 40, display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
              <Link to="/#contact" style={{ ...btnCoral(), padding: "14px 24px", fontSize: 15, textDecoration: "none" }}>
                Book a demo instead <ArrowUpRight size={16} />
              </Link>
              <Link to="/pricing-public" style={{ background: "transparent", color: T.ink, border: `1px solid ${T.line}`, padding: "14px 22px", fontSize: 15, fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 8 }}>
                Back to pricing
              </Link>
              <Link to="/" style={{ background: "transparent", color: T.inkMuted, border: "none", padding: "14px 8px", fontSize: 14, fontWeight: 500, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}>
                <MessageSquare size={14} /> Chat with our AI first
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </PageShell>
  );
}
